module.exports = __webpack_public_path__ + "img/square-poll-vertical.16fe8f91.svg";